export default "__VITE_ASSET__DWl4HWYn__"